import React from 'react';
import { Img } from 'react-image';
import { PositionStatus } from 'types';

interface Props {
	positionId: string;
	positionStatus: PositionStatus;
	recommendations: number | '-';
	connected: number | '-';
	isPublished?: boolean;
	handleViewRecommendations: () => void;
	inPipeLineUsers: number | '-';
	hideRecommendations?: boolean;
	optionalData?: { title: string; data: number }[];
}

const TextFooter = (args: { text: string }) => {
	return (
		<div className="px-4 py-5 bg-[#FAFAFC] dark:bg-[#111E2C] flex items-center border-t border-[#E4E4EB] dark:border-0 rounded-b-[12px]">
			<div className="text-xs font-medium text-orange-500 dark:text-[#FDDD48]">{args.text}</div>
		</div>
	);
};

const RecruiterPositionCardFooter = ({
	positionStatus,
	isPublished,
	recommendations,
	connected,
	handleViewRecommendations,
	hideRecommendations = false,
	inPipeLineUsers,
	optionalData,
}: Props) => {
	if (positionStatus === PositionStatus.CLOSED && !isPublished)
		return <TextFooter text="This job posting was under review and has now been closed" />;
	if (positionStatus === PositionStatus.CLOSED) return <TextFooter text="This job posting is closed" />;
	if (!isPublished || (Number(recommendations) <= 2 && Number(inPipeLineUsers) === 0 && Number(connected) === 0))
		return <TextFooter text="This job posting is under review" />;
	return (
		<div
			onClick={handleViewRecommendations}
			className="py-2 px-4 bg-[#FAFAFC] dark:bg-[#111E2C] flex items-center border-t border-[#E4E4EB] dark:border-0 rounded-b-[12px]"
		>
			<div className="bg-[#FAFAFC] dark:bg-[#111E2C] flex items-center grow-2" onClick={handleViewRecommendations}>
				<div className="flex gap-4">
					{hideRecommendations ? null : (
						<div className="pl-2 border-l-[2px] border-solid border-[#AC5DD9] bg-[#FFE5FF] shadow-up rounded-r-lg pr-[6px]">
							<div className="text-[10px] md:text-[12px] dark:text-[#28293D]">
								{optionalData?.length ? optionalData[0]?.title : 'Recommendations'}
							</div>
							<div className="text-sm font-medium text-[#28293D]">
								{optionalData?.length ? optionalData[0]?.data : recommendations}
							</div>
						</div>
					)}

					<div className="pl-2 border-l-[2px] border-solid border-[#39D98A] bg-[#E3FFF1] shadow-up rounded-r-lg pr-[6px]">
						<div className="text-[10px] md:text-[12px] dark:text-[#28293D]">
							{optionalData?.length ? optionalData[1].title : 'Connected'}
						</div>
						<div className="text-sm font-medium text-[#28293D]">
							{optionalData?.length ? optionalData[1]?.data : connected}
						</div>
					</div>

					<div className="pl-2 border-l-[2px] border-solid border-[#FDAC42] bg-[#FFF8E5] shadow-up rounded-r-lg pr-[6px]">
						<div className="text-[10px] md:text-[12px] dark:text-[#28293D]">
							{optionalData?.length ? optionalData[2]?.title : 'In Pipeline'}
						</div>
						<div className="text-sm font-medium text-[#28293D]">
							{optionalData?.length ? optionalData[2]?.data : inPipeLineUsers}
						</div>
					</div>
				</div>
			</div>
			<div className="">
				<Img src={'/assets/chevronRightBlue.svg'} alt="chevronRightBlue" width={24} height={24} />
			</div>
		</div>
	);
};

export default RecruiterPositionCardFooter;
